import React, { useState } from "react";
import { ToggleIcon, getIcon } from "../../util/icons";

export const FilterCategory = (props) => {
    const { name, setQueryVar, variables, isMultiSelect = false } = props;
    const [isOpen, setIsOpen] = useState(false);

    const toggleOpen = () => {
        setIsOpen(!isOpen);
    };

    const isChecked = variables[name] === "";

    return (
        <div className="filter-category">
            <div
                className={`toggle-wrap ${isOpen && "toggle-rotate"}`}
                onClick={toggleOpen}
            >
                <h5>{props.title}</h5>
                <ToggleIcon />
            </div>
            {isOpen && (
                <div className="dropdown-content">
                    {!isMultiSelect && (
                        <div className="filter-option">
                            <label htmlFor={`${name}-All`}>
                                <div className="filter-option-svg">
                                    {getIcon(isMultiSelect, isChecked)}
                                </div>
                                <input
                                    type={isMultiSelect ? "checkbox" : "radio"}
                                    name={name}
                                    id={`${name}-All`}
                                    value={""}
                                    checked={isChecked}
                                    onChange={(e) => {
                                        setQueryVar(name, "");
                                    }}
                                />
                                All
                            </label>
                        </div>
                    )}
                    {props.options.map((item) => (
                        <FilterOption option={item} {...props} />
                    ))}{" "}
                </div>
            )}
        </div>
    );
};

const FilterOption = ({
    name,
    setQueryVar,
    option,
    variables,
    isMultiSelect = false,
    options
}) => {
    const isChecked = isMultiSelect
        ? variables[name].find((o) => o === option.id)
        : variables[name] === option.id;

    return (
        <div className="filter-option">
            <label htmlFor={`${name}-${option.title}`}>
                <div className="filter-option-svg">
                    {getIcon(isMultiSelect, isChecked)}
                </div>
                <input
                    type={isMultiSelect ? "checkbox" : "radio"}
                    name={name}
                    id={`${name}-${option.title}`}
                    value={option.id}
                    checked={isChecked}
                    onChange={(e) => {
                        const value = isMultiSelect
                            ? Number(e.target.value)
                            : e.target.value;
                        setQueryVar(name, value, isMultiSelect, options);
                    }}
                />
                {option.title}
            </label>
        </div>
    );
};
